<script setup lang="ts">
defineProps<{
  page: any
  lazy: boolean
}>()
</script>

<template>
  <article
    v-if="page"
    class="cms-tile"
  >
    <div class="cms-tile__wrapper">
      <div class="cms-tile__content">
        <h3
          class="cms-tile__heading"
        >
          <AppLink
            class="cms-tile__link"
            :to="page?.PageUrl?.url"
          >
            {{ page?.PageTitle }}
          </AppLink>
        </h3>

        <p
          class="cms-tile__description"
        >
          <UiRichtext
            v-if="page?.Description"
            :html="page?.Description?.replaceAll('\n', '<br/>')"
          />
        </p>

        <div
          aria-hidden="true"
          class="cms-tile__button button"
        >
          <span>{{ $t('Read more') }}</span>
        </div>
      </div>

      <div
        class="cms-tile__visual"
      >
        <picture v-if="page?.Image?.url">
          <source
            :srcset="useXcdnImage(page.Image.url, 'f=rs:fit:436')"
            media="(min-width: 1024px)"
          >
          <source
            :srcset="useXcdnImage(page.Image.url, 'f=rs:fit:436')"
            media="(min-width: 768px)"
          >
          <source
            :srcset="useXcdnImage(page.Image.url, 'f=rs:fit:436')"
          >
          <img
            class="cms-tile__image"
            :src="useXcdnImage(page.Image.url, 'f=rs:fit:436')"
            :alt="page.Image.alternativeText || page.PageTitle"
            :width="page.Image.width"
            :height="page.Image.height"
            :loading="lazy ? 'lazy' : 'eager'"
            :fetchpriority="lazy ? 'low' : 'high'"
            :decoding="lazy ? 'async' : 'sync'"
          >
        </picture>
      </div>
    </div>

    <!-- <pre>page: {{ page }}</pre> -->
  </article>
</template>

<style>
@import url("~layers/app/components/Cms/Tile.css");
</style>
